import { EMPTY_TOP_SEARCHES } from 'Constants/sitemap';
import {
    getTopSearchesIdFromUrl,
    makeTopSearchesSitemapUrl } from 'Helpers/topSearches';

export const urls = {
    getTopSearches: makeTopSearchesSitemapUrl,
    getSitemap: ({ bucketUrl, siteCode, key }) =>
        `${bucketUrl}/${siteCode}/${key}.json`
};

export const iniState = {
    states: [],
    cities: [],
    categories: [],
    topSearches: {},
    fetchingTopSearches: {}
};

const setSitemap = key => (state, action) => ({
    ...state,
    [key]: action.data.data.list
});

const setStates = setSitemap('states');
const setCities = setSitemap('cities');
const setCategories = setSitemap('categories');

const setTopSearches = (state, {
    url,
    data: {
        data: searches
    }
}) => {
    const id = getTopSearchesIdFromUrl(url);

    return {
        ...state,
        topSearches: {
            ...state.topSearches,
            [id]: {
                ...EMPTY_TOP_SEARCHES,
                ...searches
            }
        },
        fetchingTopSearches: {
            ...state.fetchingTopSearches,
            [id]: false
        }
    };
};

const toggleFetching = toggle => (state, { url }) => ({
    ...state,
    fetchingTopSearches: {
        ...state.fetchingTopSearches,
        [getTopSearchesIdFromUrl(url)]: toggle
    }
});

const fetchTopSearches = toggleFetching(true);
const errorTopSearches = toggleFetching(false);

export default (state = iniState, action) => {
    switch (action.type) {
        case 'RECEIVE_SITEMAP_STATES':
            return setStates(state, action);
        case 'RECEIVE_SITEMAP_CITIES':
            return setCities(state, action);
        case 'RECEIVE_SITEMAP_CATEGORIES':
            return setCategories(state, action);
        case 'RECEIVE_SITEMAP_TOP_SEARCHES':
            return setTopSearches(state, action);
        case 'ERROR_SITEMAP_TOP_SEARCHES':
            return errorTopSearches(state, action);
        case 'REQUEST_SITEMAP_TOP_SEARCHES':
            return fetchTopSearches(state, action);
        default:
            return state;
    }
};
